import { Navigate, useLocation } from 'react-router-dom'
import { usePlayer } from '../hooks/usePlayer.js'
import { saveReturn } from '../lib/returnUrl.js'

/**
 * Protege rutas privadas. Redirige a /login si no hay sesión.
 * Muestra un estado de carga mientras Supabase resuelve la sesión inicial
 * para evitar un flash de redirección en cada recarga de página.
 */
export default function AuthGuard({ children }) {
  const { session, loading } = usePlayer()
  const location = useLocation()

  if (loading) {
    return (
      <div className="auth-loading">
        <div className="auth-spinner" />
      </div>
    )
  }

  if (!session) {
    // El enlace de un torneo o partido (p. ej. desde un correo o un aviso) se
    // recupera después de entrar. Solo si se abrió desde fuera (primera página
    // de la visita, location.key 'default'): al cerrar sesión estando en un
    // torneo no debe guardarse para el siguiente que entre en ese móvil
    if (/^\/(torneo|partido)\/\d+$/.test(location.pathname) && (location.key === 'default' || location.search.includes('c='))) saveReturn(location.pathname + location.search)
    return <Navigate to="/login" replace />
  }

  return children
}
